import { type PaginationState } from '@tanstack/react-table'
import { useContext, useState } from 'react'

import BrokersMemberContext from 'components/context/BrokersMemberContext'

import QualifyingLifeEventsTable from './QualifyingLifeEventsTable'

type QualifyingLifeEventsViewProps = {
  memberId: string
}

const QualifyingLifeEventsView = ({
  memberId,
}: QualifyingLifeEventsViewProps) => {
  const { planYear } = useContext(BrokersMemberContext)

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 5,
  })

  return (
    <div className='space-y-4'>
      <div className='flex items-center justify-between'>
        <div className='heading-md'>Dependent Additions</div>
      </div>
      <QualifyingLifeEventsTable
        planYear={planYear}
        pagination={pagination}
        setPagination={setPagination}
        memberId={memberId}
      />
    </div>
  )
}

export default QualifyingLifeEventsView
